import { FC } from "react"
import styles from "./FriendsTab.module.scss"
import { FriendsGrid, InviteHero } from "./ui"

export const FriendsTab: FC = () => {
  return (
    <div className={styles.FriendsTab}>
      <InviteHero />
      <FriendsGrid />
    </div>
  )
}
